// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "form>*+*[data-v-3271d739]{margin-top:20px}input[data-v-3271d739]{border:0px solid}.buttons[data-v-3271d739]{display:grid;grid-template-columns:1fr 1fr;column-gap:15%}.add-new-payment-method[data-v-3271d739]{margin-bottom:16px}.add-new-payment-method-controls[data-v-3271d739]{display:grid;text-align:center;padding:4px}.add-new-payment-method-link[data-v-3271d739]{color:#03b5da;text-align:center;font-size:0.9rem}\n", ""]);
// Exports
module.exports = exports;
